import { memo } from 'react';

interface IIconCollapseProps {
  className?: string;
}

export const IconCollapse = memo(({ className }: IIconCollapseProps) => (
  <svg className={className} viewBox="0 0 22 15" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 14.17L0.507004 3.677L4.179 0.00499916L11 6.816L17.816 0L21.492 3.676L11 14.17Z" />
  </svg>
));
